export default __webpack_public_path__ + "ee196b30e203482bde903b6998ff6f45.png";